<template>
  <div>
    <h1>Staff Credit Tracking</h1>

    <!-- bof request list -->
    <staff-project-list-table
      :editable="editable"
      :staff-id="staffId"
      :is-admin="isAdmin"
    />
    <!-- eof request list -->

    <!-- bof child staff request list -->
    <div
      class="card my-2"
    >
      <div class="card-body">
        <div class="card-title">
          <h3>Staff Requests</h3>
        </div>
        <!-- Date range filter -->
        <div class="row my-3">
          <div class="col">
            <vc-date-picker
              v-model="range"
              :model-config="modelConfig"
              is-range
            >
              <template #default="{ inputValue, inputEvents }">
                <div class="flex justify-center items-center">
                  <input
                    :value="inputValue.start"
                    class="border px-1 pb-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                    v-on="inputEvents.start"
                  >
                  -
                  <input
                    :value="inputValue.end"
                    class="border px-1 pb-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                    v-on="inputEvents.end"
                  >

                  <button
                    class="btn btn-primary btn-sm"
                    @click="getStaffCreditTracking(staffId)"
                  >
                    Filter
                  </button>
                  <div
                    v-if="loadingRequests"
                    class="spinner-grow text-primary"
                    role="status"
                  >
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </template>
            </vc-date-picker>
          </div>
        </div>
        <!-- eof Date range filter -->
        <div
          v-if="staffs.length"
          class="table-responsive"
        >
          <table class="table table-bordered table-striped table-vcenter">
            <thead class="table-dark">
              <tr>
                <th>Staff Name</th>
                <th>Staff Credits</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="staff in staffs"
                :key="staff.id"
              >
                <td>
                  <a
                    :href="getStaffCreditUrl(staff.id)"
                  >{{ staff.user.full_name }}</a>
                </td>
                <td>{{ staff.total_month_credits }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          v-else
          class="alert alert-info"
        >
          <small>No data</small>
        </div>
      </div>
    </div>
    <!-- eof child staff request list -->
  </div>
</template>

<script>
import StaffProjectListTable from "./StaffProjectListTable.vue";
import {mapGetters, mapActions} from "vuex";
import moment from "moment-timezone";
export default {
    name: "StaffCreditTrackingTable",
    components: {
        StaffProjectListTable
    },
    props: {
        staffId:{
            type: Number,
            default: 0
        },
        requestList: {
            type: Array,
            default: () => []
        },
        editable: {
            type: Boolean,
            default: false
        },
        isAdmin:{
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            range: {
                start: moment().startOf('month').format('YYYY-MM-DD'),
                end: moment().endOf('month').format('YYYY-MM-DD')
            },
            modelConfig: {
                end: {
                    timeAdjust: '23:59:59',
                },
            },
            loadingRequests: false
        }
    },
    computed : {
        ...mapGetters({
            staffs: "credit/requestedStaffList"
        })
    },
    mounted(){
        this.getStaffCreditTracking(this.staffId);
    },
    methods : {
        async getStaffCreditTracking(staffId){
            try {
                this.loadingRequests = true
                await this.getRequestedStaffList({
                    staffId: staffId,
                    startDate: this.range.start,
                    endDate: this.range.end
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.loadingRequests = false
            }
        },
        getStaffCreditUrl(staffId){
            const url = `admin/credit-tracking/staff/${ staffId }`;
            const staffUrl = new URL(url, window.location.origin);
            staffUrl.searchParams.append('start_date', moment(this.range.start).format('YYYY-MM-DD'));
            staffUrl.searchParams.append('end_date', moment(this.range.end).format('YYYY-MM-DD'));

            return staffUrl
        },
        ...mapActions ({
            'getRequestedStaffList': 'credit/getRequestedStaffList'
        })
    },
}
</script>

<style scoped>

</style>
